import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1cb6d91e")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_v_chart = _resolveComponent("v-chart")!

  return (_openBlock(), _createBlock(_component_v_chart, {
    class: "chart",
    option: _ctx.option,
    theme: _ctx.theme,
    autoresize: ""
  }, null, 8, ["option", "theme"]))
})